<template>
  <section>
    <h1 class="title is-size-4">
      {{ step.attributes.title }}
    </h1>
    <p v-if="step.attributes.description" class="step-description">
      <read-more
        more-str="Full content"
        :text="step.attributes.description"
        link="#"
        less-str="Hide content"
        :max-chars="200"
      ></read-more>
    </p>
  </section>
</template>

<script>
export default {
  props: ['step']
}
</script>

<style lang="scss">
.step-description {
  overflow-wrap: break-word;
  white-space: pre-wrap;
}
</style>
